export const mutations = {
  init: ({
    state
  }) => _ => {
    return state;
  },
  editSearchTerm: ({
    term
  }) => state => {
    return {
      ...state,
      next: {
        ...state.next,
        search: term
      },
      prev: {
        ...state.prev,
        search: term
      },
      searchTerm: term
    };
  },
  setFilterStatuses: ({
    statuses
  }) => state => {
    return {
      ...state,
      filterStatuses: statuses
    };
  },
  setFilterJurisdictions: ({
    jurisdictions
  }) => state => {
    return {
      ...state,
      filterJurisdictions: jurisdictions
    };
  },
  setFilterDateBefore: ({
    date
  }) => state => {
    return {
      ...state,
      filterDateBefore: date
    };
  },
  clearFilterDateBefore: () => state => {
    delete state['filterDateBefore'];
    return state;
  },
  setFilterDateAfter: ({
    date
  }) => state => {
    return {
      ...state,
      filterDateAfter: date
    };
  },
  clearFilterDateAfter: () => state => {
    delete state['filterDateAfter'];
    return state;
  },
  setCurrentPage: ({
    page
  }) => state => {
    return {
      ...state,
      page: page
    };
  }
};
export const initialState = () => ({
  assignmentsByProject: [],
  page: 1,
  totalPages: 1,
  next: {
    limit: '0',
    offset: '0',
    search: ''
  },
  prev: {
    limit: '0',
    offset: '0',
    search: ''
  }
});